"use client";

import { useEffect } from "react";

/**
 * Keeps `<html lang>` in step with the rendered locale.
 *
 * `<html>` is owned by the root layout, which stays synchronous so the
 * marketing and docs trees keep prerendering; it therefore cannot know the
 * locale at render time. Assistive technology reads `lang` to pick a
 * pronunciation, so leaving it at "en" on a Spanish page is a real defect
 * rather than a cosmetic one, and this closes it on hydration.
 *
 * The same technique already runs on this element: next-themes writes `class`
 * on `<html>` from the client, which is why the root layout carries
 * `suppressHydrationWarning`.
 */
export function HtmlLangSync({ locale }: { locale: string }) {
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return null;
}
